import { Check, Error, FileUpload } from "@mui/icons-material";
import { CircularProgress, Stack, Typography } from "@mui/material";

import { MediaUploadItem } from "../../types";

type Props = {
    item: MediaUploadItem;
};

function GetIndicator({ item }: { item: MediaUploadItem }) {
    switch (item.type) {
        case "CreatingMedia":
            return <CircularProgress size="24px" />;
        case "UploadingMedia":
            return <CircularProgress variant="determinate" value={item.progress} size="24px" />;
        case "FinishedMedia":
            return <Check />;
        case "ErrorMedia":
            return <Error />;
    }
}

export default function FileUploadItem({ item }: Props) {
    return (
        <Stack direction="row" gap={2} alignItems="center" height="40px" width={1}>
            <FileUpload />
            <Stack direction="column" flex={1}>
                <Typography variant="body2">{item.fileName}</Typography>
                {item.type === "ErrorMedia" && (
                    <Typography variant="caption" color="error">
                        {item.error}
                    </Typography>
                )}
            </Stack>
            <GetIndicator item={item} />
        </Stack>
    );
}
